import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { Link } from "react-router-dom";
import Select from "react-select";
function Add(props) {
  const [plantLocation, setPlantLocation] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [plantList, setPlantList] = useState([]);
  const [product, setProduct] = useState([]);
  const [batchSize, setBatchSize] = useState("");
  const [noOFBatch, setNoOfBatch] = useState("");

  useEffect(() => {
    getPlantList();
    getproduct();
  }, []);

  const getPlantList = () => {
    utils
      .callAPI("get", `/purchaseorder/plant/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setPlantList(res?.result);
        } else {
          setPlantList([]);
        }
      })
      .catch((err) => {
        setPlantList([]);
      });
  };

  const getproduct = () => {
    utils
      .callAPI("get", `/Product/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setProduct(res?.result);
        } else {
          setProduct([]);
        }
      })
      .catch((err) => {
        setProduct([]);
      });
  };

  const handlePlantSelection = (e) => {
    const selectedPlantId = e.target.value;
    setPlantLocation(selectedPlantId);

    const selectedPlant = plantList.find(
      (plant) => plant.id === selectedPlantId,
    );
    if (selectedPlant) {
      setBatchSize(selectedPlant.batch_size);
    } else {
      setBatchSize("");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      const bodyFormData = new FormData();
      //   if (props.rowData && Object.keys(props.rowData).length > 0) {
      //     bodyFormData.append("id", props.rowData.id);
      //   }

      bodyFormData.append("product_id", selectedProduct);
      bodyFormData.append("plant_id", plantLocation);
      bodyFormData.append("plant_batch_size", batchSize);
      bodyFormData.append("no_of_batch", noOFBatch);

      utils
        .callAPI("post", `/production/batch/save`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
            setIsSubmit(false);
          } else {
            setIsSubmit(false);
          }
        })
        .catch(() => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const productOptions = product.map((p) => ({
  value: p.id,
  label: `${p.product_name} - ${p?.size} ${p?.unit?.toUpperCase() || ""}`,
}));

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <h4></h4>
          <div className="card-header-action">
            <Link className="btn btn-underline me-2" onClick={handleBackClick}>
              Back
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Col md={6} className="mt-3">
                {/* <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="productName"
                    label="Product Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      value={selectedProduct}
                      onChange={(e) => setSelectedProduct(e.target.value)}
                      required
                    >
                      <option value="">Select Product Name</option>
                      {product.map((plant) => (
                        <option key={plant.id} value={plant.id}>
                          {plant.product_name}
                        </option>
                      ))}
                    </RB.Form.Select>
                    <RB.Form.Control.Feedback type="invalid">
                      Please select a product.
                    </RB.Form.Control.Feedback>
                  </RB.FloatingLabel>
                </div> */}
                <Select
                  options={productOptions}
                  value={
                    productOptions.find((p) => p.value === selectedProduct) ||
                    null
                  }
                  onChange={(selected) =>
                    setSelectedProduct(selected ? selected.value : "")
                  }
                  isClearable
                  placeholder="Select Product"
                  className="bom-productName-select"
                />
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="plantLocation"
                    label="Plant Location/Code"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      value={plantLocation}
                      onChange={handlePlantSelection}
                      required
                    >
                      <option value="">Select Plant Location</option>
                      {plantList.map((plant) => (
                        <option key={plant.id} value={plant.id}>
                          {plant.plant_name}
                        </option>
                      ))}
                    </RB.Form.Select>
                    <RB.Form.Control.Feedback type="invalid">
                      Please select a plant location.
                    </RB.Form.Control.Feedback>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Batch Size"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Batch Size"
                      value={batchSize}
                      readOnly
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="No Of Batch"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter No Of Batch"
                      value={noOFBatch}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setNoOfBatch(value);
                        }
                      }}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <div className="text-end mt-3">
              <RB.Button type="submit" variant="primary" className="ms-1">
                Submit
              </RB.Button>
            </div>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
